import { csvFileNamePart } from '@evogard/domain';

/**
 * O arquivo saindo pelo navegador.
 *
 * A regra do formato — separador, escape, decimal — mora em `@evogard/domain`,
 * onde tem teste. Aqui fica só o que é navegador e por isso não tem como ser
 * testado sem um: o `Blob`, a URL temporária e a âncora que dispara o download.
 */

/**
 * Monta o arquivo e o entrega.
 *
 * O U+FEFF na frente é a marca de ordem de byte: sem ela, o Excel em português
 * abre o arquivo em Latin-1 e todo acento vira caractere trocado — num arquivo
 * cuja primeira coluna costuma ser nome de gente.
 *
 * `name` vem sem extensão e sem base: os dois entram aqui, para que dois
 * arquivos exportados de praças diferentes não se sobrescrevam na pasta de
 * downloads de quem opera as duas.
 */
export function saveCsv(content: string, name: string, tenantName: string): void {
  /* A marca vai como escape, e não como o caractere colado no arquivo: literal
     ele é invisível no editor, e o lint da casa recusa espaço irregular em
     código — com razão, porque é assim que um caractere de controle entra num
     arquivo sem ninguém ver. */
  const blob = new Blob([`\uFEFF${content}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name}-${csvFileNamePart(tenantName)}.csv`;
  /*
   * A âncora entra no documento antes do clique, e sai depois.
   *
   * Clicar numa âncora que nunca esteve na página funciona no Chrome e é
   * ignorado em silêncio no Firefox — o botão responde, nada baixa, e não há
   * erro em lugar nenhum. Duas linhas compram as duas famílias.
   */
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  /*
   * O `revoke` sai do quadro atual.
   *
   * Sem isto o blob fica na memória da aba até ela fechar, e uma exportação de
   * um ano inteiro não é pequena — mas revogar na mesma linha do clique corre
   * com o início do download e o cancela em alguns navegadores. `setTimeout(0)`
   * põe a liberação depois de o navegador ter pegado os bytes.
   */
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
